import { Container } from "aurelia-dependency-injection";
import { AppSettings } from "./../../app-settings";
import { AdvancedSearchModel } from "./advanced-search";
import { AuthorizationModel } from "./../../authentication/models/authorization-model";
import { prop } from "../../decorators/property";
import { backboneModelProperties } from "../../decorators/backbone-properties";
import { AdvancedSearchFieldHelpModel } from "./advanced-search-field-help";
import { AppUser } from "../../authentication/app-user";
import { AuthService } from "../../authentication/auth-service";
import { ContainerHelper } from "../../shared/helpers/container-helper";

@backboneModelProperties({
    relations : [{
        type: Backbone.One,
        key: "Help",
        relatedModel: AdvancedSearchFieldHelpModel
    }],
    defaults: {
        Help: null,
    }
})
export class AdvancedSearchFieldModel extends AuthorizationModel {

    @prop() public AdvancedSearch: AdvancedSearchModel;
    @prop() public Id: string;
    @prop() public TemplateName: string;
    @prop() public FieldName: string;
    @prop() public Uid: string;
    @prop() public FieldValue = "";
    @prop() public FieldValue2 = "";
    @prop() public FieldLabel: string;
    @prop() public SearchLabel: string;
    @prop() public ShowOnForm: boolean;
    @prop() public Removable: boolean;
    /** Used as a flag so the SearchModule knows when user enters data into advanced form */
    @prop() public KeyPressed: boolean;
    @prop() public FilteredOut = false;
    @prop() public SearchForm: string;
    @prop() public Help: AdvancedSearchFieldHelpModel;
    @prop() public ApplicableIndicators: string;
    @prop() public Disabled: boolean;
    @prop() public PlaceHolderText: string;

    private user: AppUser;

    constructor(options?) {
        super(options);
        this.user = ContainerHelper.AuthService.AppUser;
    }

    public removeField() {
        return new Promise((resolve, reject) => {
            this.FieldValue = "";
            this.FieldValue2 = "";
            this.ShowOnForm = false;

            if (this.user.canUserSaveSearchForm()) {
                const url = AppSettings.SearchApiUrlPrefix + "removefield/" + this.SearchForm + "/" + this.Id;
                $.ajax({
                    url: url,
                    method: "GET",
                    beforeSend: AuthorizationModel.attachAuthorizationHeader
                });
            }
            resolve();
        });
    }

    public addField() {
        return new Promise((resolve, reject) => {

        this.ShowOnForm = true;

        if (this.user.canUserSaveSearchForm()) {
            const url = AppSettings.SearchApiUrlPrefix + "addfield/" + this.SearchForm + "/" + this.Id;
            $.ajax({
                url: url,
                method: "GET",
                beforeSend: AuthorizationModel.attachAuthorizationHeader
            });
        }
        resolve();
        });
    }

    public announceKeyPress() {
        this.AdvancedSearch.trigger("KeyPressed");
    }

    public getSearchLabel() { // Some fields may not have a SearchLabel set in Raven
        return this.SearchLabel ? this.SearchLabel : this.FieldLabel;
    }

    public setContents(contents: string): void {
        this.FieldValue = contents;
    }

    public setField2Contents(contents: string): void {
        this.FieldValue2 = contents;
    }

    public setPlaceHolderText(contents: string): void {
        this.PlaceHolderText = contents;
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/search/models/advanced-search-field.ts